// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__362IY","index":"styles_index__2CWZL"};